
import {Vector2} from "./geometry";

const pointRadius = new Vector2(4, 6);
const pointSpeed = new Vector2(0.4, 0.4);

const canvasPointNumber = 0 ;
const canvasPointDistance = 100;

//const pointSpeed = new Vector2(0, 0);


function getRandomFloatInRange(a, b) {
    return Math.random() * (b - a) + a;
}

async function LoadJSON (path, callback) {
    try {
        const response = await fetch(`${process.env.PUBLIC_URL}/${path}`); // Update with your file path
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        const jsonData = await response.json();
        // console.log("JSONDATA: ",JSON.stringify(jsonData));
        callback(jsonData);
    } catch (error) {
        console.error('Error fetching the JSON file:', error);
    }
}

async function LoadBIN(path, callback) {
    try {
        const response = await fetch(`${process.env.PUBLIC_URL}/${path}`);
        if (!response.ok) {
            throw new Error('Network response was not ok: ' + response.statusText);
        }

        const arrayBuffer = await response.arrayBuffer();
        const dataView = new DataView(arrayBuffer);
        const data = [];
        let offset = 0;
        const GROUP_SIZE_BYTES = 2;  // 2 bytes for group size
        const POINT_SIZE = 7;      // 7 bytes per point (52 bits)

        while (offset + GROUP_SIZE_BYTES <= dataView.byteLength) {
            // Read the group size (2 bytes)
            const groupSize = dataView.getUint16(offset, false);  // Big-endian
            offset += GROUP_SIZE_BYTES;

            const group = [];

            for (let i = 0; i < groupSize; i++) {
                if (offset + POINT_SIZE > dataView.byteLength) {
                    throw new Error('Unexpected end of data while reading points.');
                }

                let packedData = BigInt(0);
                for (let j = 0; j < POINT_SIZE; j++) {
                    packedData = (packedData << 8n) + BigInt(dataView.getUint8(offset + j));
                }
                offset += POINT_SIZE;

                // Extract values
                const x = Number((packedData >> 38n) & 0x3FFFn);  // 14 bits for x
                const y = Number((packedData >> 24n) & 0x3FFFn);  // 14 bits for y
                const r = Number((packedData >> 16n) & 0xFFn);    // 8 bits for r
                const g = Number((packedData >> 8n) & 0xFFn);     // 8 bits for g
                const b = Number(packedData & 0xFFn);            // 8 bits for b

                // console.log(packedData, (packedData >> 38), x);
                
                const point = { x, y };
                if (r !== 0 || g !== 0 || b !== 0) { // Include color only if non-zero
                    point.r = r;
                    point.g = g;
                    point.b = b;
                }
                if (offset == 9){
                    console.log(point.x, point.y);
                }
                
                group.push(point);
            }

            data.push(group);
        }

        // console.log(JSON.stringify(data));
        callback(data);
    } catch (error) {
        console.error('Error fetching or processing the BIN file:', error);
    }
}




async function LoadHTML (path, callback) {
    try {
        const response = await fetch(`${process.env.PUBLIC_URL}/${path}`); // Update with your file path
        if (!response.ok) {
            callback("Unable to find HTML file");
            throw new Error('Network response was not ok ' + response.statusText);
        } else{
            const data = await response.text();
            callback(data);
        }
    } catch (error) {
        console.error('Error fetching the HTML file:', error);
    }
}

const getImageSize = (data) => {
    let leftTop = new Vector2(9999999, 99999999);
    let rightBot = new Vector2(-9999999, -99999999);
    data.forEach((contour) => {
        contour.forEach ((point) => {
            leftTop.x = Math.min(leftTop.x, point.x);
            rightBot.x = Math.max(rightBot.x, point.x);
            
            leftTop.y = Math.min(leftTop.y, point.y);
            rightBot.y = Math.max(rightBot.y, point.y);
        });
    });

    return new Vector2(rightBot.x - leftTop.x + 1, rightBot.y - leftTop.y + 1);
}

const scaleImage = (data, scale) => {
    data.forEach((contour) => {
        contour.forEach ((point) => {
            point.x *= scale.x;
            point.y *= scale.y;
        });
    });
}

const getCenterPosition = (element) => {
    const rect = element.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    return new Vector2(centerX, centerY);
}

const getElementPositionOnCanvas = (canvas, element, anchorX, anchorY) => {
    const elementRect = element.getBoundingClientRect();
    const canvasRect = canvas.getBoundingClientRect();

    // Calculate the position of the element's center relative to the canvas
    let x = elementRect.left - canvasRect.left;
    let y = elementRect.top - canvasRect.top;

    x += elementRect.width * anchorX;
    y += elementRect.height * anchorY;
    return new Vector2(x, y);
}

class EventEmitter {
    constructor() {
        this.events = {};
    }

    // Add an event listener
    on(event, listener) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(listener);
    }

    // Remove an event listener
    off(event, listener) {
        if (!this.events[event]) return;

        this.events[event] = this.events[event].filter(l => l !== listener);
    }

    // Emit an event
    emit(event, ...args) {
        if (!this.events[event]) return;

        this.events[event].forEach(listener => listener(...args));
    }
}

/**
 * fits an image inside the desired size. Scales it with respect to aspect ratio
 * @param {Vector2} originalSize original image size
 * @param {Vector2} canvasSize target size
 * @returns {Vector2}
 */
function getFittedSize(originalSize, canvasSize) {
  
    // Calculate the aspect ratio of the original image
    const originalAspectRatio = originalSize.x / originalSize.y;
  
    // Calculate the aspect ratio of the canvas
    const canvasAspectRatio = canvasSize.x / canvasSize.y;
  
    let newWidth, newHeight;
  
    // If the original aspect ratio is greater than the canvas aspect ratio,
    // the limiting factor is the width of the canvas
    if (originalAspectRatio > canvasAspectRatio) {
      newWidth = canvasSize.x;
      newHeight = canvasSize.x / originalAspectRatio;
    } else {
      // Otherwise, the limiting factor is the height of the canvas
      newWidth = canvasSize.y * originalAspectRatio;
      newHeight = canvasSize.y;
    }
  
    // Return the new size as an object
    return new Vector2(newWidth, newHeight);
}

function getDeviceType() {
    // OVERRIDE FOR NOW

    // return "PC";

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
    // Detect mobile devices
    if (/android/i.test(userAgent)) {
      return 'ANDROID';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'IOS';
    }
  
    // Default to PC
    return 'PC';
}

function removeUniformly(arr, m) {
    if (m >= arr.length) {
        return;
    }

    const interval = arr.length / (m + 1);
    for (let i = m; i > 0; i--) {
        const indexToRemove = Math.floor(i * interval);
        arr.splice(indexToRemove, 1);
    }
}




export {pointRadius, pointSpeed, canvasPointNumber, canvasPointDistance, EventEmitter, removeUniformly, getDeviceType, getElementPositionOnCanvas, getFittedSize, getRandomFloatInRange, LoadJSON, LoadBIN, LoadHTML, scaleImage, getImageSize, getCenterPosition};